import React, { useState, useEffect } from "react";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import Accounts from "./Accounts";
// import SaleSummary from "./SaleSummary/SaleSummary";
import SummarySale from "./SaleSummary/SummarySale";

const AccsDashboard = () => {
  const [selectedLabel, setSelectedLabel] = useState("Accounts");
  const location = useLocation();
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  // Define the button routes here
  const AccountsUserButton = [
    { label: "Expenses", path: "/Accounts" },
    // { label: "Sale Summary", path: "/SaleSummary" },
    { label: "Summary Sale", path: "/SummarySale" },
    
    // You can add more buttons for other pages like SwiggyNewOrder, etc.
  ];

  useEffect(() => {
    const currentPathSegment = location.pathname.split("/").pop();
    // Update selected label based on current path
    const currentButton = AccountsUserButton.find(
      (button) => button.path.replace("/", "") === currentPathSegment
    );
    if (currentButton) {
      setSelectedLabel(currentButton.label);
    }
  }, [location.pathname]); // Re-run on pathname change

  const handleButtonClick = () => setSidebarVisible(false);
  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

  return (
    <>
      {/* Navbar */}
      <nav className="navbar shadow p-3 bg-body rounded navbar-light bg-light d-flex align-items-center">
        <span className="navbar-brand mb-0 h1">
          <i>BillTrace</i> Accounts User
        </span>
        {/* <h5 className="selected-label ">{selectedLabel}</h5> */}
        {isSidebarVisible ? (
          <IoClose
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        ) : (
          <IoMenu
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        )}
      </nav>

      {/* Sidebar & Main Content */}
      <div className="d-flex">
        {/* Sidebar */}
        <div className={`sidebar ${isSidebarVisible ? "open" : ""}`}>
          <div className="button-container mt-2">
            {AccountsUserButton.map((button, index) => (
              <Link
                key={index}
                to={`/AccsDashboard${button.path}`} // Absolute path within the dashboard
                className="btn btn-primary mb-2 MasterCreationButtons"
                onClick={handleButtonClick}
              >
                {button.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <Routes>
            {/* Redirect to /AccsDashboard/UserMaster if no route matches */}
            <Route path="/" element={<Navigate to="/AccsDashboard/Accounts" replace />} />
            {/* Add the routes for each page inside the dashboard */}
            <Route path="/Accounts" element={<Accounts />} />
            {/* <Route path="/SaleSummary" element={<SaleSummary />} /> */}
            <Route path="/SummarySale" element={<SummarySale />} />
           
            
            {/* You can add more child routes here */}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default AccsDashboard;

